module.exports = __webpack_public_path__ + "img/album21_32.7b2719cb.jpg";